import axiosClient from "./axiosClient";

const studentApi = {
    searchStudent: async (params: any) => {
        const res = await axiosClient.get("/student", {
            params,
        });
        return res;
    },
    getTotalStudentOfCurrentMonth: async () => {
        const res = await axiosClient.get("/student/statistics/current-month");
        return res;
    },
    getTotalStudentOfYear: async (params: any) => {
        const res = await axiosClient.get("/student/statistics/by-month", {
            params,
        });
        return res;
    },
    createStudent: async (data: any) => {
        const res = await axiosClient.post("/student", data);
        return res;
    },
    updateProfileStudent: (id: number, data: any) => {
        const res = axiosClient.patch(`/student/${id}`, data)
        return res;
    },
    deleteStudent: (id: number) => {
        return axiosClient.delete(`/students/${id}`);
    },
    getStudentNotAssignedClass: async (params: { page?: number; limit?: number }) => {
        const res = await axiosClient.get("/student/not-assigned-class", { params });
        return res;
    },
};

export default studentApi;
